import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class QuotePaxValidator extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		const properties = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;
		const validator = this.getValidator();
		this.message = '';

		const requiredFields = ['foreName', 'surName', 'birthDate', 'gender'];
		for (const field of requiredFields) {
			if (properties.find(p => p === field) != null) {
				const displayName: any = dynamicProperties[field] as any;
				if (!validator.isNotEmpty(displayName)) {
					const errorMessage = `${field[0].toUpperCase() + field.substr(1)} is required`;
					this.message = this.message.concat(`${errorMessage}<br />`);
					result = false;
				}
			}
		}

		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/quote-pax-validator.ts